import UtsavTextField from "src/globalModule/components/UtsavTextField";
import { makeStyles } from "@material-ui/core";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import CloseIcon from "@mui/icons-material/Close";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import PersonIcon from "@mui/icons-material/Person";
import { Box, Button, Checkbox, Grid, Menu, MenuItem, Modal, Stack, Typography, useMediaQuery } from "@mui/material";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import playStoreImage from "@public/assets/onboardingImages/playStoreImage1.png";
import applogo2 from "@public/logo1.png";
import { loginEmail as emailLoginRequest, forgotPasswordApi } from "@queries/auth.queries";
import { domain } from "@utils/BASE-URL";
import { trackEvent, trackPeopleAuth, trackUserAttributes } from "@utils/analytics/event-analytics";
import { SMS_TEMPLATE, WEB_ENGAGE } from "@utils/constants";
import { getEncryptedCookieUserData } from "@utils/cookie/cookies";
import Image from "next/legacy/image";
import Link from "next/link";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { useTranslation } from "react-i18next";
import OTPMODEL from "src/globalModule/components/otp";
import theme from "src/globalModule/styles/theme";
import UtsavNewModal from "src/globalModule/views/UtsavNewModal";
import { ThemeProvider } from "styled-components";
import { addUser, sendOTP, verifyOTP } from "../queries/auth.queries";
import classes from "../styles/onboardingBigScreen.module.css";
import { useDispatch } from "react-redux";
import { setUserData } from "@utils/reduxToolkit/features/userSlice";
const useStyles = makeStyles(theme => ({
  logoText: {
    ...theme.typography.h4,
    fontFamily: "'Berkshire swash', sans-serif"
  },
  text: {
    fontFamily: "'Quicksand', sans-serif"
  },
  heading: {
    fontFamily: "'Poppins', sans-serif"
  }
}));
const Item = styled(Paper)(({
  theme
}) => ({
  // backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  // padding: theme.spacing(1),
  // textAlign: "center",
  color: theme.palette.text.secondaryDark,
  width: "100%",
  boxShadow: "none"
}));
function OnboardingBigScreen({
  isLoginModalOpen,
  handleClose,
  reset
}) {
  const {
    t
  } = useTranslation();
  const router = useRouter();
  const [mobileNo, setMobileNo] = useState("");
  const [tcWatsapp, setTCWatsapp] = useState(true);
  const [stepNo, setStepNo] = useState(1);
  const [showRetry, setShowRetry] = useState(false);
  const [timer, setTimer] = useState(30);
  const [verificationKey, setVerificationKey] = useState("");
  const [accessToken, setAccessToken] = useState("");
  const [name, setName] = useState("");
  const [data, setData] = useState(null);
  const [, setCookie] = useCookies(["token"]);
  const [contactAdded, setContactAdded] = useState(WEB_ENGAGE.DECISION.YES);
  const [emailAdded, setEmailAdded] = useState(WEB_ENGAGE.DECISION.YES);
  const styles = useStyles();
  const smallScreen = useMediaQuery("(max-width:700px)");
  const [emailLogin, setEmailLogin] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [errorModal, setErrorModal] = useState({
    open: false,
    heading: "",
    message: "",
    acceptMethod: () => {},
    icon: null,
    positive: false
  });
  const dispatch = useDispatch();
  //console.log("isLoginModalOpen", isLoginModalOpen);

  useEffect(() => {
    if (isLoginModalOpen) {
      if (stepNo === 1) {
        if (!emailLogin) {
          trackEvent(WEB_ENGAGE.SCREEN_NAMES.CONTACT_ONBOARDING_SCREEN + +" " + WEB_ENGAGE.EVENT_NAMES.SCREEN_VIEWED + {
            [WEB_ENGAGE.EVENT_PROPERTIES.SCREEN_NAME]: WEB_ENGAGE.SCREEN_NAMES.CONTACT_ONBOARDING_SCREEN
          });
        } else {
          trackEvent(WEB_ENGAGE.SCREEN_NAMES.EMAIL_LOGIN_ONBOARDING_SCREEN + +" " + WEB_ENGAGE.EVENT_NAMES.SCREEN_VIEWED + {
            [WEB_ENGAGE.EVENT_PROPERTIES.SCREEN_NAME]: WEB_ENGAGE.SCREEN_NAMES.EMAIL_LOGIN_ONBOARDING_SCREEN
          });
        }
      } else if (stepNo === 2) {
        trackEvent(WEB_ENGAGE.SCREEN_NAMES.OTP_ONBOARDING_SCREEN + +" " + WEB_ENGAGE.EVENT_NAMES.SCREEN_VIEWED + {
          [WEB_ENGAGE.EVENT_PROPERTIES.SCREEN_NAME]: WEB_ENGAGE.SCREEN_NAMES.OTP_ONBOARDING_SCREEN
        });
      } else if (stepNo === 3) {
        trackEvent(WEB_ENGAGE.SCREEN_NAMES.CREATE_PROFILE + +" " + WEB_ENGAGE.EVENT_NAMES.SCREEN_VIEWED + {
          [WEB_ENGAGE.EVENT_PROPERTIES.SCREEN_NAME]: WEB_ENGAGE.SCREEN_NAMES.CREATE_PROFILE
        });
      }
    }
  }, [stepNo, emailLogin, isLoginModalOpen]);
  useEffect(() => {
    let intervalId;
    if (timer > 0) {
      intervalId = setInterval(() => {
        setTimer(prevTimer => prevTimer - 1);
      }, 1000);
    } else {
      setShowRetry(true);
    }
    return () => {
      clearInterval(intervalId);
    };
  }, [timer]);
  useEffect(() => {
    // console.log("closeLoginModal reset", reset);
    if (reset) {
      setStepNo(1);
    }
  }, [reset]);
  function handleOnChange(e) {
    let inputValue = e.target.value;
    inputValue = inputValue.replace(/\D/g, "");
    inputValue = inputValue?.replace(/^\+91-/, "")?.replace(/^\+91/, "")
    // ?.replace(/^91-/, "")
    // ?.replace(/^91/, "")
    ?.replace(/^0-/, "")?.replace(/^0/, "")?.replace(" ", "")?.replace("-", "");
    //console.log("handleOnChange 1", inputValue);
    if (inputValue?.length > 10) {
      return;
    }
    setMobileNo(inputValue);
    // const digitsOnly = value.replace(/\D/g, "");
    // if (digitsOnly.length > 10) return;
    // setMobileNo(digitsOnly.slice(-10));
  }
  const handleChangeName = e => {
    setName(e.target.value);
  };
  const handleEmailChange = e => {
    setEmail(e.target.value);
  };
  const handlePasswordChange = e => {
    setPassword(e.target.value);
  };
  const handleClickShowPassword = () => setShowPassword(show => !show);

  // let token = Cookies.get("token");
  // if (token) {
  //   token = JSON.parse(token);
  // }

  const isValidPhoneNumber = () => {
    const phoneNumberRegex = /^\d{10}$/;
    return phoneNumberRegex.test(mobileNo.replace(" ", "").replace("-", ""));
  };
  async function otpPageFun(e) {
    e.preventDefault();
    trackEvent(WEB_ENGAGE.SCREEN_NAMES.CONTACT_ONBOARDING_SCREEN + " " + WEB_ENGAGE.BUTTON_NAMES.GET_OTP + " " + WEB_ENGAGE.EVENT_NAMES.BUTTON_CLICKED, {
      [WEB_ENGAGE.EVENT_PROPERTIES.SCREEN_NAME]: WEB_ENGAGE.SCREEN_NAMES.CONTACT_ONBOARDING_SCREEN,
      [WEB_ENGAGE.EVENT_PROPERTIES.BUTTON_NAME]: WEB_ENGAGE.BUTTON_NAMES.GET_OTP
    });
    if (!isValidPhoneNumber()) {
      setErrorModal({
        open: true,
        heading: `${t("info")}`,
        message: `${t("please-enter-10-digits-mobile-no")}`,
        acceptMethod: () => setErrorModal({
          ...errorModal,
          open: false
        }),
        icon: <InfoOutlinedIcon sx={{
          fontSize: "3rem",
          color: "orange"
        }} />
      });
      return;
    }
    if (!mobileNo) {
      setErrorModal({
        open: true,
        heading: `${t("info")}`,
        message: `${t('enter-your-mobile-no')}`,
        acceptMethod: () => setErrorModal({
          ...errorModal,
          open: false
        }),
        icon: <InfoOutlinedIcon sx={{
          fontSize: "3rem",
          color: "orange"
        }} />
      });
      return () => {};
    }
    if (!tcWatsapp) {
      setErrorModal({
        open: true,
        heading: `${t("info")}`,
        message: `${t('please-agree-to-our-terms-and-conditions')}`,
        acceptMethod: () => setErrorModal({
          ...errorModal,
          open: false
        }),
        icon: <InfoOutlinedIcon sx={{
          fontSize: "3rem",
          color: "orange"
        }} />
      });
      return () => {};
    }
    e.target.innerText = `${t("loading")}`;
    const contact = mobileNo.replace(" ", "").replace("-", "");
    const res = await sendOTP({
      contact: contact,
      type: SMS_TEMPLATE.WEBSITE
    });
    if (!res?.success || !res.response?.verificationKey) {
      setErrorModal({
        open: true,
        heading: `${t("error")}`,
        message: `${t("something-went-wrong")}`,
        acceptMethod: () => setErrorModal({
          ...errorModal,
          open: false
        }),
        icon: <ErrorOutlineOutlinedIcon sx={{
          fontSize: "3rem",
          color: "orange"
        }} />
      });
      e.target.innerText = `${t("get-otp")}`;
      return () => {};
    }
    trackPeopleAuth(res.response.data);
    setVerificationKey(res.response.verificationKey);
    //setShowOtp(true);
    setStepNo(2);
    e.target.innerText = `${t("get-otp")}`;
  }
  async function resendOTPFun(e) {
    e.preventDefault();
    trackEvent(WEB_ENGAGE.SCREEN_NAMES.OTP_ONBOARDING_SCREEN + +" " + WEB_ENGAGE.TEXT_NAMES.RESEND_OTP + +" " + WEB_ENGAGE.EVENT_NAMES.TEXT_CLICKED, {
      [WEB_ENGAGE.EVENT_PROPERTIES.SCREEN_NAME]: WEB_ENGAGE.SCREEN_NAMES.OTP_ONBOARDING_SCREEN,
      [WEB_ENGAGE.EVENT_PROPERTIES.TEXT_NAME]: WEB_ENGAGE.TEXT_NAMES.RESEND_OTP
    });
    if (!mobileNo) {
      setErrorModal({
        open: true,
        heading: `${t("info")}`,
        message: `${t("enter-your-mobile-no")}`,
        acceptMethod: () => setErrorModal({
          ...errorModal,
          open: false
        }),
        icon: <ErrorOutlineOutlinedIcon sx={{
          fontSize: "3rem",
          color: "red"
        }} />
      });
      return () => {};
    }
    e.target.innerText = `${t("loading")}`;
    const contact = mobileNo.replace(" ", "").replace("-", "");
    const res = await sendOTP({
      contact: contact
    });
    if (!res?.success || !res.response?.verificationKey) {
      setErrorModal({
        open: true,
        heading: `${t("info")}`,
        message: `${t("something-went-wrong")}`,
        acceptMethod: () => setErrorModal({
          ...errorModal,
          open: false
        }),
        icon: <ErrorOutlineOutlinedIcon sx={{
          fontSize: "3rem",
          color: "red"
        }} />
      });
      e.target.innerText = `${t("resend-otp")}`;
      return () => {};
    }
    setVerificationKey(res.response.verificationKey);
    //setShowOtp(true);
    setTimer(30);
    setShowRetry(false);
    e.target.innerText = `${t("resend-otp")}`;
    setErrorModal({
      open: true,
      heading: `${t("resend-otp")}`,
      message: `${t("otp-sent-successfully")}`,
      acceptMethod: () => setErrorModal({
        ...errorModal,
        open: false
      }),
      icon: <CheckCircleOutlineOutlinedIcon sx={{
        fontSize: "3rem",
        color: "red"
      }} />,
      positive: true
    });
  }
  const verifyOTPHandler = async otp => {
    const contact = mobileNo.replace(" ", "").replace("-", "");
    const res = await verifyOTP({
      contact: contact,
      verificationKey: verificationKey,
      otp: otp
    });
    let encryptedUserData = null,
      encryptedUser = null;
    if (!res?.success && res?.message) {
      setErrorModal({
        open: true,
        heading: `${t("error")}`,
        message: res.message,
        acceptMethod: () => setErrorModal({
          ...errorModal,
          open: false
        }),
        icon: <ErrorOutlineOutlinedIcon sx={{
          fontSize: "3rem",
          color: "red"
        }} />
      });
      return () => {};
    }
    if (!res?.success) {
      setErrorModal({
        open: true,
        heading: `${t("error")}`,
        message: `${t("something-went-wrong-please-try-again")}`,
        acceptMethod: () => setErrorModal({
          ...errorModal,
          open: false
        }),
        icon: <ErrorOutlineOutlinedIcon sx={{
          fontSize: "3rem",
          color: "red"
        }} />
      });
      //window.location.reload();
      return () => {};
    }
    //setOtpVerificationSuccess(true);
    setAccessToken(res.response?.data?.accessToken);
    // setData({
    //   contact: res.response?.data?.authID,
    //   uid: res.response?.data?.uid,
    //   accessToken: res.response?.data?.accessToken,
    // });

    const userData = {
      name: res.response?.user?.name,
      uid: res.response?.data?.uid,
      authType: res.response?.data?.authType,
      accessToken: res.response?.data?.accessToken,
      role: res.response?.userRole?.role
    };
    dispatch(setUserData({
      userData: userData,
      lang: res.response?.user?.UserDetail.language
    }));
    setData(res.response?.data);
    const data = {
      type: "phone",
      data: res.response
    };
    // setCookie("token", data, {
    //   path: "/",
    //   maxAge: 60,
    //   secure: true,
    //   domain: domain,
    // });

    // let encryptedUserData = null,
    //   encryptedUser = null;
    const obj = getEncryptedCookieUserData(data.data);
    if (obj) {
      encryptedUser = obj.encryptedUser;
      encryptedUserData = obj.encryptedUserData;
    }
    trackPeopleAuth(res.response.data);
    if (res.isRegistered) {
      try {
        trackUserAttributes(res.response.user);
        trackEvent(WEB_ENGAGE.EVENT_NAMES.USER_AUTH_SUCCESS, {
          [WEB_ENGAGE.EVENT_PROPERTIES.SCREEN_NAME]: WEB_ENGAGE.SCREEN_NAMES.OTP_ONBOARDING_SCREEN,
          [WEB_ENGAGE.EVENT_PROPERTIES.AUTH_METHOD]: WEB_ENGAGE.AUTH_METHODS.PHONE,
          [WEB_ENGAGE.EVENT_PROPERTIES.USER_TYPE]: WEB_ENGAGE.USER_TYPE.OLD
        });
      } catch (error) {
        alert("error in track user attributes", error);
      }
      handleClose();
      setCookie("utsavUser", encryptedUser, {
        path: "/",
        secure: true,
        sameSite: "none",
        domain: domain,
        maxAge: 60 * 60 * 24 * 7 //7-days
      });
      setCookie("utsavData", encryptedUserData, {
        path: "/",
        secure: true,
        sameSite: "none",
        domain: domain,
        maxAge: 60 * 60 * 24 * 7 //7-days
      });

      // setShowOtp(false);
      // setShowLogin(true);
      // router.reload();
      // const url = `${window.location.pathname}`;
      // router.push(url);
      // const params = "newUser=true";
      // const url = `${window.location.pathname}?${params}`;
      // //router.push(url);
      // window.location.replace(url);
      router.reload();
      return () => {};
    }
    // setNameSection(true);
    // setShowOtp(false);
    // setShowLogin(true);

    setStepNo(3);
    trackEvent(WEB_ENGAGE.EVENT_NAMES.USER_AUTH_SUCCESS, {
      [WEB_ENGAGE.EVENT_PROPERTIES.SCREEN_NAME]: WEB_ENGAGE.SCREEN_NAMES.OTP_ONBOARDING_SCREEN,
      [WEB_ENGAGE.EVENT_PROPERTIES.AUTH_METHOD]: WEB_ENGAGE.AUTH_METHODS.PHONE,
      [WEB_ENGAGE.EVENT_PROPERTIES.USER_TYPE]: WEB_ENGAGE.USER_TYPE.NEW
    });
  };
  const emailLoginHandler = async e => {
    e.preventDefault();
    let encryptedUserData = null,
      encryptedUser = null;
    trackEvent(WEB_ENGAGE.SCREEN_NAMES.EMAIL_LOGIN_ONBOARDING_SCREEN + " " + WEB_ENGAGE.BUTTON_NAMES.SIGN_IN_EMAIL + " " + WEB_ENGAGE.EVENT_NAMES.BUTTON_CLICKED, {
      [WEB_ENGAGE.EVENT_PROPERTIES.SCREEN_NAME]: WEB_ENGAGE.SCREEN_NAMES.EMAIL_LOGIN_ONBOARDING_SCREEN,
      [WEB_ENGAGE.EVENT_PROPERTIES.BUTTON_NAME]: WEB_ENGAGE.BUTTON_NAMES.SIGN_IN_EMAIL
    });
    if (!email) {
      setErrorModal({
        open: true,
        heading: `${t("info")}`,
        message: `${t("enter-your-email")}`,
        acceptMethod: () => setErrorModal({
          ...errorModal,
          open: false
        }),
        icon: <InfoOutlinedIcon sx={{
          fontSize: "3rem",
          color: "orange"
        }} />
      });
      return () => {};
    }
    if (!password) {
      setErrorModal({
        open: true,
        heading: `${t("info")}`,
        message: `${t("enter-your-password")}`,
        acceptMethod: () => setErrorModal({
          ...errorModal,
          open: false
        }),
        icon: <InfoOutlinedIcon sx={{
          fontSize: "3rem",
          color: "orange"
        }} />
      });
      return () => {};
    }
    try {
      const result = await emailLoginRequest({
        email,
        password
      });
      if (result) {
        trackEvent(WEB_ENGAGE.EVENT_NAMES.USER_AUTH_SUCCESS, {
          [WEB_ENGAGE.EVENT_PROPERTIES.SCREEN_NAME]: WEB_ENGAGE.SCREEN_NAMES.EMAIL_LOGIN_ONBOARDING_SCREEN,
          [WEB_ENGAGE.EVENT_PROPERTIES.AUTH_METHOD]: WEB_ENGAGE.AUTH_METHODS.EMAIL,
          [WEB_ENGAGE.EVENT_PROPERTIES.USER_TYPE]: WEB_ENGAGE.USER_TYPE.OLD
        });

        // console.log("Email Login response=====>", result);
        if (result.isEmailVerified && result.isRegistered) {
          trackPeopleAuth(result.response.data);
          //console.log("after track people auth");
          try {
            trackUserAttributes(result.response.user);
          } catch (error) {
            //console.log("error in track user attributes", error);
          }
          //console.log("after track user attributes");

          //console.log("after track event");
          setAccessToken(result.response?.data?.accessToken);
          const userData = {
            name: result.response?.user?.name,
            uid: result.response?.data?.uid,
            authType: result.response?.data?.authType,
            accessToken: result.response?.data?.accessToken,
            role: result.response?.userRole?.role
          };
          dispatch(setUserData({
            userData: userData,
            lang: result.response?.user?.UserDetail.language
          }));
          setData(result.response?.data);
          const data = {
            type: "email",
            data: result.response
          };
          const obj = getEncryptedCookieUserData(data.data);
          if (obj) {
            encryptedUser = obj.encryptedUser;
            encryptedUserData = obj.encryptedUserData;
          }
          handleClose();
          setCookie("utsavUser", encryptedUser, {
            path: "/",
            secure: true,
            sameSite: "none",
            domain: domain,
            maxAge: 60 * 60 * 24 * 7 //7-days
          });
          setCookie("utsavData", encryptedUserData, {
            path: "/",
            secure: true,
            sameSite: "none",
            domain: domain,
            maxAge: 60 * 60 * 24 * 7 //7-days
          });
          router.reload();
          return () => {};
          // setCookie("token", data, {
          //   path: "/",
          //   maxAge: 60,
          //   secure: true,
          //   domain: domain,
          // });
          // //console.log("Email Login response=====>", data);
          // // trackEvent("Authentication Success", { Type: "Email Login" });

          // router.push({ pathname: "/auth/login", query: redirect });
          // router.push({ pathname: "/auth/login", query: { ...router.query } });
        }
        // else if (result.isEmailVerified === false) {
        //   toggleOpenEmailVerificationResendModal();
        // } else if (result.isRegistered === false) {
        //   trackPeopleAuth(result.response.data);

        //   const data = { type: "email", data: result.response };
        //   setCookie("token", data, {
        //     path: "/",
        //     maxAge: 60,
        //     secure: true,
        //     domain: domain,
        //   });
        //   router.push({ pathname: "/auth/register", query: redirect });
        // }
        else if (result.message) {
          //alert(result.message);
          //console.log("result====>",result);

          setErrorModal({
            open: true,
            heading: `${t("info")}`,
            message: result.message,
            acceptMethod: () => setErrorModal({
              ...errorModal,
              open: false
            }),
            icon: <InfoOutlinedIcon sx={{
              fontSize: "3rem",
              color: "orange"
            }} />,
            positive: true
          });
        }
      }
    } catch (err) {
      alert(err.message);
    }
  };
  const forgotPassword = async () => {
    trackEvent(WEB_ENGAGE.SCREEN_NAMES.EMAIL_LOGIN_ONBOARDING_SCREEN + " " + WEB_ENGAGE.TEXT_NAMES.FORGOT_PASSWORD + " " + WEB_ENGAGE.EVENT_NAMES.TEXT_CLICKED, {
      [WEB_ENGAGE.EVENT_PROPERTIES.SCREEN_NAME]: WEB_ENGAGE.SCREEN_NAMES.EMAIL_LOGIN_ONBOARDING_SCREEN,
      [WEB_ENGAGE.EVENT_PROPERTIES.TEXT_NAME]: WEB_ENGAGE.TEXT_NAMES.FORGOT_PASSWORD
    });
    if (!email) {
      setErrorModal({
        open: true,
        heading: `${t("info")}`,
        message: `${t("enter-your-email")}`,
        acceptMethod: () => setErrorModal({
          ...errorModal,
          open: false
        }),
        icon: <InfoOutlinedIcon sx={{
          fontSize: "3rem",
          color: "orange"
        }} />
      });
      return () => {};
    }
    // trackEvent("Authentication Forgot Password Clicked");

    const forgotPasswordResponse = await forgotPasswordApi(email);
    // print(forgotPasswordResponse)
    if (forgotPasswordResponse.success) {
      setErrorModal({
        open: true,
        heading: `${t("success")}`,
        message: `${t("password-reset-link-has-been-sent-to")} ${email}!`,
        acceptMethod: () => setErrorModal({
          ...errorModal,
          open: false
        }),
        icon: <CheckCircleOutlineOutlinedIcon sx={{
          fontSize: "3rem",
          color: "red"
        }} />
      });
    } else {
      // if (forgotPasswordResponse.code === "auth/user-not-found") {
      if (forgotPasswordResponse.code === 500) {
        setErrorModal({
          open: true,
          heading: `${t("info")}`,
          message: `${t("no-user-found-with-this-email-address-please-sign-up")}`,
          acceptMethod: () => setErrorModal({
            ...errorModal,
            open: false
          }),
          icon: <InfoOutlinedIcon sx={{
            fontSize: "3rem",
            color: "orange"
          }} />
        });
      } else {
        setErrorModal({
          open: true,
          heading: `${t("error")}`,
          message: `${t("something-went-wrong-please-try-again")}`,
          acceptMethod: () => setErrorModal({
            ...errorModal,
            open: false
          }),
          icon: <ErrorOutlineOutlinedIcon sx={{
            fontSize: "3rem",
            color: "red"
          }} />
        });
      }
    }
  };
  const submitHandler = async e => {
    //console.log("'handler:", e);
    trackEvent(WEB_ENGAGE.SCREEN_NAMES.CREATE_PROFILE + " " + WEB_ENGAGE.BUTTON_NAMES.USER_REGISTER + " " + WEB_ENGAGE.EVENT_NAMES.BUTTON_CLICKED, {
      [WEB_ENGAGE.EVENT_PROPERTIES.SCREEN_NAME]: WEB_ENGAGE.SCREEN_NAMES.CREATE_PROFILE,
      [WEB_ENGAGE.EVENT_PROPERTIES.BUTTON_NAME]: WEB_ENGAGE.BUTTON_NAMES.USER_REGISTER
    });
    if (e) e.preventDefault();
    if (!name) {
      setErrorModal({
        open: true,
        heading: `${t("info")}`,
        message: `${t("enter-your-name")}`,
        acceptMethod: () => setErrorModal({
          ...errorModal,
          open: false
        }),
        icon: <InfoOutlinedIcon sx={{
          fontSize: "3rem",
          color: "orange"
        }} />
      });
      return () => {};
    }
    const registrationDoc = {
      name: name,
      dp: null,
      UserDetail: {
        contact: mobileNo,
        email: null,
        whatsappEnabled: tcWatsapp
      },
      UserAddress: {},
      UserMetric: {},
      UserReferral: {},
      communityIDs: []
    };
    const createdUser = await addUser({
      data: registrationDoc,
      accessToken
    });
    if (createdUser) {
      let authType;

      // if (token.type === "phone") {
      authType = WEB_ENGAGE.AUTH_METHODS.PHONE;
      // } else {
      //   authType = WEB_ENGAGE.AUTH_METHODS.GOOGLE;
      // }
      const token = {
        type: "phone",
        data: {
          user: null
        }
      };
      if (token.type === "email" || token.type === "phone") {
        const newToken = token;
        newToken.data.data = data;
        newToken.data.user = createdUser;
        let encryptedUserData = null,
          encryptedUser = null;
        const obj = getEncryptedCookieUserData(newToken.data);
        if (obj) {
          encryptedUser = obj.encryptedUser;
          encryptedUserData = obj.encryptedUserData;
        }
        // setCookie("token", newToken, {
        //   maxAge: 300,
        //   secure: true,
        //   domain: domain,
        // });
        setCookie("utsavUser", encryptedUser, {
          path: "/",
          secure: true,
          sameSite: "none",
          domain: domain,
          maxAge: 60 * 60 * 24 * 7 //7-days
        });
        setCookie("utsavData", encryptedUserData, {
          path: "/",
          secure: true,
          sameSite: "none",
          domain: domain,
          maxAge: 60 * 60 * 24 * 7 //7-days
        });
        setCookie("newUser", true, {
          maxAge: 60 * 60 * 24 * 7,
          //7-days
          secure: true,
          domain: domain
        });
      }
      try {
        trackUserAttributes(createdUser);
      } catch (error) {
        alert("error in track user attributes", error);
      }
      trackEvent(WEB_ENGAGE.EVENT_NAMES.USER_REGISTRATION_SUCCESS, {
        [WEB_ENGAGE.EVENT_PROPERTIES.SCREEN_NAME]: WEB_ENGAGE.SCREEN_NAMES.CREATE_PROFILE,
        [WEB_ENGAGE.EVENT_PROPERTIES.AUTH_METHOD]: authType,
        [WEB_ENGAGE.EVENT_PROPERTIES.CONTACT_ADDED]: contactAdded
      });
      handleClose();
      router.reload();

      // setTimeout(() => {
      //   // const queryParams = new URLSearchParams(window.location.search);
      //   // const params = queryParams.toString();
      //   // const params = "newUser=true";
      //   // const url = `${window.location.pathname}?${params}`;
      //   // router.push(url);
      //   // router.reload();
      // }, 3000);
    } else {
      alert(`${t("something-went-wrong")}`);
    }
  };
  const [anchorEl, setAnchorEl] = useState(null);
  const [subMenuOpen, setSubMenuOpen] = useState(Boolean(anchorEl));
  const subMenuHandleClick = event => {
    trackEvent(WEB_ENGAGE.SCREEN_NAMES.CONTACT_ONBOARDING_SCREEN + " " + WEB_ENGAGE.TEXT_NAMES.MORE_OPTIONS + " " + WEB_ENGAGE.EVENT_NAMES.TEXT_CLICKED, {
      [WEB_ENGAGE.EVENT_PROPERTIES.SCREEN_NAME]: WEB_ENGAGE.SCREEN_NAMES.CONTACT_ONBOARDING_SCREEN,
      [WEB_ENGAGE.EVENT_PROPERTIES.TEXT_NAME]: WEB_ENGAGE.TEXT_NAMES.MORE_OPTIONS
    });
    setAnchorEl(event.currentTarget);
    setSubMenuOpen(true);
  };
  const subMenuHandleClose = () => {
    setAnchorEl(null);
    setSubMenuOpen(false);
  };
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "75%",
    bgcolor: "background.paper",
    overflow: "hidden",
    // paddingTop: "1em",
    borderRadius: "15px",
    outline: "none"
  };
  return <ThemeProvider theme={theme} data-sentry-element="ThemeProvider" data-sentry-component="OnboardingBigScreen" data-sentry-source-file="onboardingBigScreen.jsx">
      <Modal open={isLoginModalOpen} onClose={handleClose} data-sentry-element="Modal" data-sentry-source-file="onboardingBigScreen.jsx">
        <Box sx={style} data-sentry-element="Box" data-sentry-source-file="onboardingBigScreen.jsx">
          <Grid container spacing={2} sx={{
          mt: 0,
          ml: 0,
          width: "100%"
        }} data-sentry-element="Grid" data-sentry-source-file="onboardingBigScreen.jsx">
            {!smallScreen && <Grid item container md={6} className={classes.onboardingBgImg} direction={"column"} justifyContent={"space-between"} sx={{
            pl: 4,
            pt: 4,
            pb: 4
          }}>
                <Grid item>
                  <Grid item container alignItems={"center"}>
                    <Image src={applogo2} alt={t("utsav-logo")} width={50} height={50} priority />
                    <Typography variant="h4" sx={{
                  color: "white"
                }} className={styles.logoText}>
                      {t("utsav")}
                    </Typography>
                  </Grid>

                  {/* <Grid item sx={{ mt: 2 }}>
                    <Typography
                      variant="body1"
                      sx={{
                        color: "white",
                        fontSize: "40px",
                        fontWeight: 600,
                      }}
                      className={styles.heading}
                    >
                      Start your spiritual journey with us.
                    </Typography>
                   </Grid> */}
                </Grid>

                <Grid item>
                  <Grid item sx={{
                mb: 1
              }}>
                    <Typography variant="body1" sx={{
                  color: "white",
                  fontSize: "40px",
                  fontWeight: "bold"
                }} className={styles.heading}>
                      {t("start-your-spiritual-journey-with-utsav")}
                    </Typography>
                  </Grid>
                  <Grid item sx={{
                mt: 1
              }}>
                    <Link href="https://play.google.com/store/apps/details?id=com.applex.utsav"
                //className={classes.section1_download_link}
                target="blank" rel="alternate" hrefLang={router.locale}>
                      <Image src={playStoreImage} alt={t("utsav-desktop-view")} height={45} width={150} />
                    </Link>
                  </Grid>
                </Grid>
              </Grid>}

            <Grid item container md={6} style={{
            paddingLeft: 0
          }} data-sentry-element="Grid" data-sentry-source-file="onboardingBigScreen.jsx">
              <Box sx={{
              width: "100%"
            }} data-sentry-element="Box" data-sentry-source-file="onboardingBigScreen.jsx">
                {stepNo === 1 && <MoreVertIcon onClick={subMenuHandleClick} sx={{
                position: "absolute",
                top: "5%",
                right: "3%",
                cursor: "pointer",
                // backgroundColor: "#F2F2F2",
                borderRadius: "50%"
              }} id="basic-button" aria-controls={subMenuOpen ? "basic-menu" : undefined} aria-haspopup="true" aria-expanded={subMenuOpen ? "true" : undefined} />}
                {stepNo === 2 && <ArrowBackIcon sx={{
                position: "absolute",
                top: "5%",
                left: "53%",
                cursor: "pointer",
                // backgroundColor: "#F2F2F2",
                borderRadius: "50%"
              }} onClick={() => {
                if (stepNo === 2) {
                  setStepNo(1);
                }
              }} />}
                <Menu id="basic-menu" anchorEl={anchorEl} open={subMenuOpen} onClose={subMenuHandleClose} MenuListProps={{
                "aria-labelledby": "basic-button"
              }} anchorOrigin={{
                vertical: "top",
                horizontal: "left"
              }} transformOrigin={{
                vertical: "top",
                horizontal: "right"
              }} data-sentry-element="Menu" data-sentry-source-file="onboardingBigScreen.jsx">
                  {!emailLogin ? <MenuItem onClick={() => {
                  subMenuHandleClose();
                  setEmailLogin(true);
                  setStepNo(1);
                }}>
                      <PersonIcon />
                      <span style={{
                    marginLeft: "5px"
                  }}>
                        {t("sign-in-with-email")}
                      </span>
                    </MenuItem> : <MenuItem onClick={() => {
                  subMenuHandleClose();
                  setEmailLogin(false);
                  setStepNo(1);
                }}>
                      <PersonIcon />
                      <span style={{
                    marginLeft: "5px"
                  }}>{t("sign-in")}</span>
                    </MenuItem>}
                  <MenuItem onClick={() => {
                  subMenuHandleClose();
                  handleClose();
                }} data-sentry-element="MenuItem" data-sentry-source-file="onboardingBigScreen.jsx">
                    <CloseIcon data-sentry-element="CloseIcon" data-sentry-source-file="onboardingBigScreen.jsx" />
                    <span style={{
                    marginLeft: "5px"
                  }}>{t("close")}</span>
                  </MenuItem>
                </Menu>

                <Stack spacing={2} direction="column" justifyContent="space-between" sx={{
                height: "100%"
              }} data-sentry-element="Stack" data-sentry-source-file="onboardingBigScreen.jsx">
                  {stepNo === 1 && <Item>
                      <Stack justifyContent={"center"} alignItems={"center"} sx={{
                    pt: 10
                  }}>
                        {!emailLogin ? <>
                            <Item sx={{
                        width: "70%"
                      }}>
                              <Typography variant="h5" className={classes.formHeading}>
                                {t("enter-phone-number")}
                              </Typography>
                            </Item>

                            <Item sx={{
                        width: "70%",
                        pt: 2
                      }}>
                              <UtsavTextField label={t("enter-phone-number")} type="tel" value={mobileNo} autoComplete="tel" inputProps={{
                          inputMode: "numeric",
                          pattern: "[0-9]*"
                        }} setProps={handleOnChange} startAdornment={"+91"} />
                            </Item>

                            <Item sx={{
                        width: "70%",
                        pt: 1,
                        ml: -1
                      }}>
                              <Grid container>
                                <Grid item xs={1}>
                                  <Checkbox checked={tcWatsapp} onClick={() => {
                              if (tcWatsapp) {
                                trackEvent(WEB_ENGAGE.SCREEN_NAMES.CONTACT_ONBOARDING_SCREEN + " " + WEB_ENGAGE.EVENT_NAMES.BOX_CHECKED, {
                                  [WEB_ENGAGE.EVENT_PROPERTIES.SCREEN_NAME]: WEB_ENGAGE.SCREEN_NAMES.CONTACT_ONBOARDING_SCREEN,
                                  [WEB_ENGAGE.EVENT_PROPERTIES.CHECK_STATUS]: WEB_ENGAGE.DECISION.YES
                                });
                              } else {
                                trackEvent(WEB_ENGAGE.SCREEN_NAMES.CONTACT_ONBOARDING_SCREEN + " " + WEB_ENGAGE.EVENT_NAMES.BOX_CHECKED, {
                                  [WEB_ENGAGE.EVENT_PROPERTIES.SCREEN_NAME]: WEB_ENGAGE.SCREEN_NAMES.CONTACT_ONBOARDING_SCREEN,
                                  [WEB_ENGAGE.EVENT_PROPERTIES.CHECK_STATUS]: WEB_ENGAGE.DECISION.NO
                                });
                              }
                              setTCWatsapp(prev => !prev);
                            }} sx={{
                              color: "#27ae60",
                              "&.Mui-checked": {
                                color: "#27ae60"
                              }
                            }} />
                                </Grid>
                                <Grid item container xs={11} justifyContent={"flex-start"} alignItems={"center"} sx={{
                            pl: 1
                          }}>
                                  <Typography className={classes.checkCondition}>
                                    {t("send-puja-updates-on-whatsapp")}
                                  </Typography>
                                </Grid>
                              </Grid>
                            </Item>
                            <Item sx={{
                        width: "70%",
                        mt: 3
                      }}>
                              <Button color="primary" // Add the desired color value here
                        className={classes.button} onClick={e => {
                          otpPageFun(e);
                          //setStepNo(2);
                        }}
                        // onKeyPress={(event) => {
                        //   if (event.key === "Enter") {
                        //     event.preventDefault();
                        //     event.stopPropagation();
                        //     // Call the button's onClick function
                        //     onClick();
                        //   }
                        // }}
                        >
                                {t("get-otp")}
                              </Button>
                            </Item>
                          </> : <>
                            <Item sx={{
                        width: "70%"
                      }}>
                              <Typography variant="h5" className={classes.formHeading}>
                                {t("enter-your-email")}
                              </Typography>
                            </Item>

                            <Item sx={{
                        width: "70%",
                        pt: 2
                      }}>
                              <UtsavTextField label={t("enter-your-email")} type="email" value={email} autoComplete="tel"
                        // inputProps={{
                        //   inputMode: "numeric",
                        //   pattern: "[0-9]*",
                        // }}
                        setProps={handleEmailChange}
                        // startAdornment={"+91"}
                        />
                            </Item>
                            <Item sx={{
                        width: "70%",
                        pt: 1
                      }}>
                              <UtsavTextField label={t("enter-your-password")} type="password" value={password} autoComplete="password"
                        // inputProps={{
                        //   inputMode: "numeric",
                        //   pattern: "[0-9]*",
                        // }}
                        setProps={handlePasswordChange} endAdornmentClick={handleClickShowPassword} showPassword={showPassword}
                        // startAdornment={"+91"}
                        />
                            </Item>
                            <Item sx={{
                        width: "70%",
                        pt: 1
                      }} onClick={forgotPassword}>
                              <Grid container sx={{
                          width: "100%",
                          justifyContent: "flex-end"
                        }}>
                                <Grid item>{t("forgot-password")}</Grid>
                              </Grid>
                            </Item>
                            <Item sx={{
                        width: "70%",
                        mt: 3
                      }}>
                              <Button color="primary" // Add the desired color value here
                        className={classes.button} onClick={e => {
                          emailLoginHandler(e);
                          //setStepNo(2);
                        }}
                        // onKeyPress={(event) => {
                        //   if (event.key === "Enter") {
                        //     event.preventDefault();
                        //     event.stopPropagation();
                        //     // Call the button's onClick function
                        //     onClick();
                        //   }
                        // }}
                        >
                                {t("login")}
                              </Button>
                            </Item>
                          </>}
                      </Stack>
                    </Item>}
                  {stepNo === 2 && <Item>
                      <Stack justifyContent={"center"} alignItems={"center"} sx={{
                    pt: 10
                  }}>
                        <Item sx={{
                      width: "60%"
                    }}>
                          <Typography variant="h5" className={classes.formHeading}>
                            {t("otp-verification")}
                          </Typography>
                        </Item>
                        <Item sx={{
                      width: "60%",
                      pt: 4
                    }}>
                          <OTPMODEL verifyOTPHandler={verifyOTPHandler} />
                        </Item>
                        <Item sx={{
                      width: "60%",
                      mt: 2
                    }}>
                          {showRetry ? <Typography variant="body1" sx={{
                        // fontSize: "18px",
                        color: theme.palette.text.secondaryDark,
                        cursor: "pointer"
                      }} onClick={resendOTPFun}>
                              {t("resend-otp-0")}
                            </Typography> : <Typography variant="body1" sx={{
                        // fontSize: "18px",
                        color: theme.palette.text.secondaryDark
                      }}>
                              {t("didn-and-apos-t-receive-otp")}
                              <span style={{
                          color: theme.palette.text.secondaryDark
                        }}>
                                {t("retry-in")} {timer > 0 ? timer : 0} s
                              </span>
                            </Typography>}
                        </Item>
                        <Item sx={{
                      width: "60%",
                      mt: 1
                    }}>
                          <Button
                      // variant="contained"
                      // color={theme.palette.btnColor.main}
                      color="primary" // Add the desired color value here
                      sx={{
                        width: "100%",
                        borderRadius: "24px",
                        mt: 2,
                        alignItems: "center"
                      }} className={classes.button}>
                            {t("continue")}
                          </Button>
                        </Item>
                      </Stack>
                    </Item>}
                  {stepNo === 3 && <>
                      <Stack justifyContent={"center"} alignItems={"center"} sx={{
                    pt: 10
                  }}>
                        <Item sx={{
                      width: "60%"
                    }}>
                          <Typography variant="h5" className={classes.formHeading}>
                            {t("enter-your-name")}
                          </Typography>
                        </Item>
                        <Item sx={{
                      width: "60%",
                      pt: 2
                    }}>
                          <UtsavTextField type="text" value={name} autoComplete="none" label={t("enter-your-name")} setProps={handleChangeName} />
                        </Item>
                        <Item sx={{
                      width: "60%",
                      mt: 2
                    }}>
                          <Button
                      // variant="contained"
                      // color={theme.palette.btnColor.main}
                      color="primary" // Add the desired color value here
                      sx={{
                        width: "100%",
                        mt: 2
                      }} className={classes.button} onClick={e => {
                        submitHandler(e);
                      }}>
                            {t("get-started")}
                          </Button>
                        </Item>
                      </Stack>
                    </>}

                  <Item data-sentry-element="Item" data-sentry-source-file="onboardingBigScreen.jsx">
                    <Grid container item
                  // sx={{ mb: 5 }}
                  alignItems={"flex-end"} justifyContent={"center"} data-sentry-element="Grid" data-sentry-source-file="onboardingBigScreen.jsx">
                      <Grid container sx={{
                      pl: "15%",
                      pr: -1,
                      height: "120px"
                    }} data-sentry-element="Grid" data-sentry-source-file="onboardingBigScreen.jsx">
                        <Grid container item xs={9} alignItems={"center"} data-sentry-element="Grid" data-sentry-source-file="onboardingBigScreen.jsx">
                          {stepNo === 1 && <Typography variant="body1" className={classes.policyText}>
                              {t("by-continuing-you-agree-to-our")}{" "}
                              <Link href={"/terms-of-use"} target="_blank" rel="alternate" hrefLang={router.locale}>
                                <span style={{
                              color: theme.palette.secondary.main,
                              cursor: "pointer"
                            }}>
                                  {t("terms-of-service")}
                                </span>{" "}
                              </Link>
                              {t("and")}{" "}
                              <Link href={"/privacy-and-cookie-policy"} target="_blank" rel="alternate" hrefLang={router.locale}>
                                <span style={{
                              color: theme.palette.secondary.main,
                              cursor: "pointer"
                            }}>
                                  {t("privacy-policy")}
                                </span>
                              </Link>
                            </Typography>}
                        </Grid>
                        <Grid item container xs={3} className={classes.termsConditionRoot} data-sentry-element="Grid" data-sentry-source-file="onboardingBigScreen.jsx"></Grid>
                      </Grid>
                    </Grid>
                  </Item>
                </Stack>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Modal>
      {errorModal.open && <UtsavNewModal open={errorModal.open} toggleModal={() => setErrorModal(prevState => ({
      ...prevState,
      open: true
    }))} heading={errorModal.heading} message={errorModal.message} acceptMsg={t("okay")} onAccept={errorModal.acceptMethod}
    // rejectMsg="Cancel"
    icon={errorModal.icon} positive={errorModal.positive} />}
    </ThemeProvider>;
}
export default OnboardingBigScreen;